import { Icon, Surface } from '@vst/beam';

import { addonVisualConfig, VisualConfig } from '@app/components/AddonIcon/config';

import { AddonProductTypeIds } from '../../types';

const DroppedAddonIcon = ({ productTypeId }: { productTypeId: string }): JSX.Element | null => {
  const getIconProps = (productTypeId: string): VisualConfig => {
    switch (productTypeId) {
      case AddonProductTypeIds.SHIELD:
        return addonVisualConfig.SHIELD;
      case AddonProductTypeIds.STREAM:
        return addonVisualConfig.STREAM;
      case AddonProductTypeIds.STATIC_IP:
        return addonVisualConfig.STATIC_IP;
      case AddonProductTypeIds.EASY_CARE_BUNDLED:
      case AddonProductTypeIds.EASY_CARE:
        return addonVisualConfig.EASY_CARE;
      case AddonProductTypeIds.CYBER_PROTECT:
        return addonVisualConfig.CYBER_PROTECT;
      default:
        return addonVisualConfig.DEFAULT;
    }
  };

  const iconProps = getIconProps(productTypeId);

  return (
    <Surface data-cy="droppedAddonsIcon" style={{ backgroundColor: iconProps.backgroundColor }} radius="8px" p="8px">
      <Icon size="16" icon={iconProps.icon} color={iconProps.beamIconColorName} />
    </Surface>
  );
};

export default DroppedAddonIcon;
